export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.22-0918.16",
  commitId: "f2448435407a7acbdc467ca997454a218d924dd2",
  commitTime: "2026-04-22T09:18:16.000Z",
});
